import {TFunction} from 'i18next';
import {ExportCarePlanData} from '../../base/export-care-plan-types';
import {CommonPersonalDevelopmentXlsxDataProcessor} from '../export-care-plan-common-personal-development-xlsx-data';

export class SocialInteractionXlsxDataProcessor extends CommonPersonalDevelopmentXlsxDataProcessor {
  // Inherits the same headers and row structure as Common processor.

  constructor(baseData: ExportCarePlanData, t: TFunction) {
    super(baseData, t);

    this.additionalEntries = [
      this.additionalEntry.place,
      this.additionalEntry.meansOf,
      this.additionalEntry.equipmentNeeded,
      this.additionalEntry.contacts,
    ];
  }
}
